const H = {
  name: "Chip2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12Z" fill="currentColor"/>
<path d="M13 2V5H15V2H17V5.17071C17.8524 5.47199 18.528 6.14759 18.8293 7H22V9H19V11H22V13H19V15H22V17H18.8293C18.528 17.8524 17.8524 18.528 17 18.8293V22H15V19H13V22H11V19H9V22H7V18.8293C6.14759 18.528 5.47199 17.8524 5.17071 17H2V15H5V13H2V11H5V9H2V7H5.17071C5.47199 6.14759 6.14759 5.47199 7 5.17071V2H9V5H11V2H13ZM7 8V16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16V8C17 7.44772 16.5523 7 16 7H8C7.44772 7 7 7.44772 7 8Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Chip2
};
